import React, { Component } from 'react';

export default class FloatingMenu extends Component {

    constructor(props) {
		super(props);
        this.state = {};
        this.onClick = this.onClick.bind(this);

        this.scrollDown = this.scrollDown.bind(this);
        this.onPopupClick = this.onPopupClick.bind(this);
	}

    scrollDown(event) {
        const original = this.scroller.scrollTop;
        this.scroller.scrollTop += this.scroller.offsetHeight;
        if (original >= this.scroller.scrollTop) {
            this.scroller.scrollTop = 0;
        }
    }

    onPopupClick(event) {
        event.stopPropagation();
    }

    onClick(event) {

        if (this.props.disabled) {
            this.props.onShowTutorial();
            return;
        }

        this.props.onClick && this.props.onClick(event);

        
    }

	render() {

        const className = "floating-menu " + this.props.color + ' ' +this.props.name.toLowerCase();

        const style = {};
        if (this.props.disabled) {
            style.opacity = 0.2;
            style.cursor = 'default'; 
        }

		return (
			<div className={className} style={style}>

                <div className="button" onClick={this.onClick}>
                    {this.props.icon}
                    <br />
                    {this.props.name}
                </div>
              
                    <div className={(this.props.visible ? "visible " : "") + ' children'} onClick={this.onPopupClick}>
                        <div className="items">
                            <div className="scroll-container" ref={el => this.scroller = el}>                            
                                {this.props.children}
                            </div>
                        </div>
                        {
                           this.props.btnMore &&
                            <div className="more-elements" onClick={this.scrollDown}><i className="fa fa-angle-down" aria-hidden="true"></i><span>MÁS ELEMENTOS</span><i className="fa fa-angle-down" aria-hidden="true"></i></div>
                        }
                    </div>
               

                
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/FloatingMenu.js